<template>
    <div>
        <div class="search-box">
            <p>部门：</p>
            <a-tree-select
                class="input-box"
                showSearch
                v-model="selectedDeployment"
                labelInValue
                :treeData="departmentTree"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                allowClear
                treeNodeFilterProp="title"
                treeDefaultExpandAll
                @change="onChangeDep"
                >
            </a-tree-select>
            <p>工号：</p>
            <a-input class="input-box" v-model="searchFrom.doctorId" />
            <p>姓名：</p>
            <a-input class="input-box" v-model="searchFrom.doctorName" />
            <p>合作导师姓名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="edit" 
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/faculty/postdoctor/info?type=edit&id='+selectedRowKeys[0])"
                >
                 编辑
            </a-button>
            <!-- <a-button
                type="primary"
                icon="file-search" 
                class="btn" 
                v-if="permissions.indexOf('faculty:assess:query')>-1"
                @click="selectedRowKeys[0] == null ? selectedCheck() : $router.push('/admin/faculty/postdoctor/info?type=look&id='+selectedRowKeys[0])"
                >
                 查看详情
            </a-button> -->
        </div>
        <a-table 
            rowKey="doctorId"
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            :customRow="onClickRow"
            @change="handleTableChange"
            :scroll="{ x :'500px' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            
            <template slot="highestDegreeOrg" slot-scope="text,res">
                <span>{{text}}{{text==''?'':'('+res.highestEducationName+')'}}</span>
            </template>
            <template slot="id" slot-scope="text">
                <a class="action-btn" v-if="permissions.indexOf('faculty:teacher:query')>-1" @click="$router.push('/admin/faculty/teacher/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" v-if="permissions.indexOf('faculty:teacher:edit')>-1" @click="$router.push('/admin/faculty/teacher/info?type=update&id='+text)">编辑</a>
            </template>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list } from '@/baseAPI/postdoctor'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
    const columns = [
        {
            title: '序号',
            dataIndex: 'createTime',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '工号',
            dataIndex: 'doctorId',
            align:'center',
            width:120,
        },
        {
            title: '姓名',
            dataIndex: 'doctorName',
            align:'center',
            width:120,
        },
        {
            title: '人事关系所在部门',
            dataIndex: 'staffCategoryCode',
            align:'center',
            width:120,
        },
        {
            title: '专业方向',
            dataIndex: 'majorField',
            align:'center',
            width:120,
        },
        {
            title: '合作导师姓名',
            dataIndex: 'mentorTeacherName',
            align:'center',
            width:120,
        },
        {
            title: '进站日期',
            dataIndex: 'inboudDate',
            align:'center',
            width:120,
        },
        {
            title: '出站日期',
            dataIndex: 'outboudDate',
            align:'center',
            width:120,
        },
        {
            title: '待审核项',
            dataIndex: 'trialCnt',
            align:'center',
            width:100,
        },
        {
            title: '发表论文',
            dataIndex: 'paper',
            width:100,
        },
        {
            title: '科研项目',
            dataIndex: 'researchProject',
            align:'center',
            width:100,
        },
        {
            title: '专利',
            dataIndex: 'patent',
            width:100,
        },
        {
            title: '专著',
            dataIndex: 'monograph',
            width:100,
            
        },
        {
            title: '基金',
            dataIndex: 'fund',
            width:100,
            
        },
        {
            title: '奖励',
            dataIndex: 'reward',
            width:100,
            
        },
        {
            title: '学术交流',
            dataIndex: 'academicExchange',
            width:100,
            
        },
        {
            title: '社会影响',
            dataIndex: 'socialInfluence',
            width:100,
            
        },
        // {
        //   title: '操作',
        //   dataIndex: 'id',
        //   width:100,
        //   scopedSlots: { customRender: 'id' }
        // }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns:[
                        {
                            title: '序号',
                            dataIndex: 'createTime',
                            align:'center',
                            width:70,
                            customRender: (text, row, index) => {
                                return { children: index+1};
                            },
                        },
                        {
                            title: '工号',
                            dataIndex: 'doctorId',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '姓名',
                            dataIndex: 'doctorName',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '人事关系所在部门',
                            dataIndex: 'orgName',
                            align:'center',
                            width:120,
                            // customRender: (text, row, index) => {
                            //     this.departmentTree.forEach(element => {
                            //         if(element.code == text){
                            //             return element.name
                            //         }
                            //     });
                            //     return text;
                            // },
                        },
                        {
                            title: '专业方向',
                            dataIndex: 'majorField',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '合作导师姓名',
                            dataIndex: 'mentorTeacherName',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '进站日期',
                            dataIndex: 'inboudDate',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '出站日期',
                            dataIndex: 'outboudDate',
                            align:'center',
                            width:120,
                        },
                        {
                            title: '待审核项',
                            dataIndex: 'trialCnt',
                            align:'center',
                            width:100,
                        },
                        {
                            title: '发表论文',
                            dataIndex: 'paper',
                            width:100,
                        },
                        {
                            title: '科研项目',
                            dataIndex: 'researchProject',
                            align:'center',
                            width:100,
                        },
                        {
                            title: '专利',
                            dataIndex: 'patent',
                            width:100,
                        },
                        {
                            title: '专著',
                            dataIndex: 'monograph',
                            width:100,
                            
                        },
                        {
                            title: '基金',
                            dataIndex: 'fund',
                            width:100,
                            
                        },
                        {
                            title: '奖励',
                            dataIndex: 'reward',
                            width:100,
                            
                        },
                        {
                            title: '学术交流',
                            dataIndex: 'academicExchange',
                            width:100,
                            
                        },
                        {
                            title: '社会影响',
                            dataIndex: 'socialInfluence',
                            width:100,
                            
                        },
                    ],
                data:[],
                loading: false,
                pagination:{
                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                    showSizeChanger:true,
                    showTotal:total=>'共'+total+'条数据',
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    orgCode:'',
                    doctorId:'',
                    doctorName:''
                },
                xbArr:[],
                xkfxArr:[],
                zcArr:[],
                xlArr:[],
                departmentTree:[],
                selectedDeployment:{},
                selectedRowKeys: [], 
                rylbArr:[],
                permissions:[]
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            queryDepartmentTreeList().then(res => {
                this.departmentTree = res.data
            })
            getDicts({dataCode:'XB',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'XKFX',status:true}).then(res=>{
                this.xkfxArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'XL',status:true}).then(res=>{
                this.xlArr=res.data.dicts;
            })
            getDicts({dataCode:'RYLB',status:true}).then(res=>{
                this.rylbArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.doctorId])
                        }
                    },

                }  
            },
            handleTableChange(pagination, filters, sorter){
                if(typeof sorter.order!='undefined'){
                    this.searchFrom.sortField=sorter.field
                    this.searchFrom.sortOrder=sorter.order.replace('end','')
                }else{
                    this.searchFrom.sortField=''
                    this.searchFrom.sortOrder=''
                }
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                console.log(this.pagination)
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.pageSizeOptions[4]=res.data.total+'';
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            // remove(id){
            //     del(id).then(res=>{
            //         if(res.data.success){
            //             this.$notification['success']({
            //                 message: '成功',
            //                 description:'删除人事信息成功',
            //             });
            //             this.fetch()
            //         }else{
            //             this.$notification['error']({
            //                 message: '失败',
            //                 description:res.data.errorMessage,
            //             });
            //         }
            //     })
            // },
            onChangeDep (obj) {
                this.selectedDeployment=obj;
                if(obj){
                    this.searchFrom.orgCode = obj.value;
                }else{
                    this.searchFrom.orgCode = '';
                }
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            exportTable(){
                var obj=this.deepCopy(this.searchFrom);
                delete obj.size;
                delete obj.current;
                obj.idList=this.selectedRowKeys;
                exportTable(obj).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 15px;
    }
    .search-box p
    {
        display: inline-block;
        text-align: right;
    }
    /* .search-box p:nth-child(1),
    .search-box p:nth-child(12){
        width: auto;
    }
    .search-box p:nth-child(3),
    .search-box p:nth-child(14){
        width: 8rem;
    } */
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
        margin-bottom: 1rem;
        display: inline-block;
        vertical-align: top;
    }
    /* .search-box .input-box .ant-input{
        display: inline-block;
        width: calc(50% - 15px);
    } */
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
